<script>
export default {
  name: "NoticeView",
  data() {
    return {
      queryData: {
        pageNo: 1,
        pageSize: 10,
        name: '',
        userId: '',
      },
      total: 0,
      dataList: [],
      disabled: true,
      selectChange: [],
      selectChangeId: [],
      title: '',
      DialogVisible: false,
      formData: {
        id: '',
        title: '',
        image: '',
        link: '',
        describes: '',
        status: '',
        remarks: ''
      },
      formRules: {
        title: [
          {required: true, message: '请输入公告内容！', trigger: 'blur'}
        ],
        content: [
          {required: true, message: '请输入公告链接！', trigger: 'blur'}
        ],
      },
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      noticeId: '',
    }
  },
  created() {
    this.list()
  },
  methods: {
    handleUpload(option) {
      console.log(option)
      // const _this = this
      // let file = option.file;
      // lrz(file, { quality: 0.5 }).then((rst) => {
      //   let formData = new FormData();
      //   formData.append("file", rst.file);
      //   this.$axios.post('oss/classification/sts/token', formData).then(function (res) {
      //     const client = new OSS({
      //       region: res.data.data.region,
      //       accessKeyId: res.data.data.accessKeyId,
      //       accessKeySecret: res.data.data.accessKeySecret,
      //       bucket: res.data.data.bucket
      //     })
      //     const domain = res.data.data.domain
      //     const fileName = res.data.data.fileName
      //
      //     client.put(fileName, rst.file).then(() => {
      //       _this.formData.image = domain + fileName
      //     })
      //   }).catch(function (err) {
      //     _this.$message.error(err)
      //   })
      // })
    },
    list() {
      const _this = this
      this.$axios.post('notice/list', this.queryData).then(function (res) {
        _this.dataList = res.data.data.records
        _this.total = res.data.data.total
      }).catch(function (err) {
        _this.$Message.error(err)
      })
    },
    handleSizeChange(pageSize) {
      this.queryData.pageSize = pageSize
      this.list()
    },
    handleCurrentChange(pageNo) {
      this.queryData.pageNo = pageNo
      this.list()
    },
    handleSearch() {
      this.list()
    },
    clear() {
      this.list()
    },
    handleAdd: function () {
      this.title = '添加公告'
      this.DialogVisible = true
    },
    handleEdit(id) {
      this.title = '编辑公告'
      this.DialogVisible = true
      const _this = this
      const data = {
        id: id
      }
      this.$axios.post('notice/detail', data).then(function (res) {
        _this.formData = res.data.data
      }).catch(function (err) {
        _this.$Message.error(err)
      })
    },
    handleDelete(id) {
      const _this = this
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.delete(id)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    delete(id) {
      const _this = this
      const data = {
        id: id
      }
      this.$axios.post('notice/delete', data).then(function (res) {
        if (res.data.code === 200) {
          _this.$message({
            type: 'success',
            message: res.data.msg
          })
          _this.list()
        } else {
          _this.$message({
            type: 'error',
            message: res.data.msg
          })
        }
      }).catch(function (err) {
        _this.$Message.error(err)
      })
    },
    changeSelect(val) {
      this.selectChange = val
      this.lengths = this.selectChange.length
      this.disabled = this.lengths === 0
    },
    getIds() {
      for (let i = 0; i < this.selectChange.length; i++) {
        this.selectChangeId.push(this.selectChange[i].id)
      }
    },
    // 批量删除按钮
    handleDeletes() {
      const _this = this
      this.$confirm('此操作将永久删除数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.deleteAll()
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '已取消删除'
        })
        _this.selectChangeId = []
      })
    },
    deleteAll() {
      this.getIds()
      const _this = this
      this.loading = true
      this.$axios.post('notice/deletes', this.selectChangeId).then(function (res) {
        _this.$message({
          type: 'success',
          message: res.data.msg
        })
        _this.list()
      }).catch(function (err) {
        _this.$Message.error(err)
      })
    },
    handleSave() {
      const _this = this
      this.$axios.post('notice/save', this.formData).then(function (res) {
        _this.$refs.formRef.resetFields()
        _this.formData.id = ''
        _this.$message({
          type: 'success',
          message: res.data.msg
        })
        _this.DialogVisible = false
        _this.list()
      }).catch(function (err) {
        _this.$Message.error(err)
      })
    },
    handleCancel() {
      this.formData = {}
      this.$refs.formRef.resetFields()
      this.DialogVisible = false
    },
    closeDialog() {
      Object.keys(this.formData).forEach(key => this.formData[key] = '');
      this.$refs.formRef.resetFields()
      this.DialogVisible = false
    },
  }
}
</script>

<template>
  <div>
    <el-row style="margin-top:20px ">
      <el-col :span="4">
        <el-input placeholder="名称" v-model="queryData.name" clearable @clear="clear"></el-input>
      </el-col>
      <el-col :span="3" style="margin-left: 20px">
        <el-button type="primary" @click="handleSearch">搜索</el-button>
      </el-col>
    </el-row>
    <el-row style="text-align: left;margin-top: 20px">
      <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleAdd">新增</el-button>
      <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDeletes" :disabled="disabled">删除
      </el-button>
    </el-row>
    <el-table :data="dataList" style="width: 100%;margin-top: 20px" border @selection-change="changeSelect">
      <el-table-column type="selection" width="50" align="center">
      </el-table-column>
      <el-table-column label="通知标题" prop="title" :show-overflow-tooltip="true" align="center"></el-table-column>
      <el-table-column label="通知内容" prop="content" :show-overflow-tooltip="true" align="center"></el-table-column>
      <el-table-column label="创建时间" prop="createTime" align="center"></el-table-column>
      <el-table-column label="更新时间" prop="updateTime" align="center"></el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="text" @click="handleEdit(scope.row.id)">编辑</el-button>
          <el-button size="mini" type="text" @click="handleDelete(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="block" style="margin-top: 20px">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryData.pageNo"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="queryData.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>
    <el-dialog :title="title" :visible.sync="DialogVisible" width="50%" center @close='closeDialog'>
      <el-form :model="formData" :rules="formRules" ref="formRef" label-width="100px">
        <el-form-item label="通知标题" prop="title">
          <el-input v-model="formData.title"></el-input>
        </el-form-item>
        <el-form-item label="通知内容" prop="content">
          <el-input v-model="formData.content"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remarks">
          <el-input v-model="formData.remarks"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
    <el-button @click="handleCancel">取 消</el-button>
    <el-button type="primary" @click="handleSave">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<style scoped>

</style>